var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgIconInvoice = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 28,
  height: 27,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2 5h15.798v2.69H2V5Zm0 5.38h15.798v2.691H2v-2.69Zm0 5.382h10.053v2.69H2v-2.69Zm21.972-3.643-6.175 5.772-1.856-1.736-2.03 1.903 3.886 3.638L26 14.024l-2.028-1.905Z",
  fill: "#FA530A"
})));

export { SvgIconInvoice as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-invoice.7c63a62d.svg";